"use strict";

export class CurveKeyframe {
    constructor(time,inTang,outTang,value) {
        this.time = time;
        this.inTang = inTang;
        this.outTang = outTang;
        this.value = value;
    }
}